<template>
    <header class="header" id="header-section">
        <div class="header-nav">
            <div class="loader" ref="loade">
                <!-- <img class="width-img" fluid src="../assets/img/Loader.gif" alt=""> -->
                <img class="width-img load-large" fluid  :src="require('../assets/img/'+$t('header.loading'))" alt="">
                <img class="width-img load-sm" fluid  :src="require('../assets/img/'+$t('header.loadingsm'))" alt="">
                <!-- <div class="width-img" :style="{background: backgroundAdapt}"></div> -->
                <!-- :src="''+$t('header.loading')" -->
            </div>
            <!-- embed-responsive-16by9 -->
            <div class="header-video-reel embed-responsive embed-responsive-16by9" :style="{display:visibilityReel}" :class="[fullVideoReel,animate, fadeRight,slow]">
                <!-- fullVideoReel -->
                <b-icon icon="x" @click="close_reel" ref="iconClose" class="close-reel"></b-icon>

                <video ref="video_reel" id="video-reelw" class="reel" >
                    <source src="../assets/video/PortafolioReel-low.mp4" type="video/mp4">
                </video>

                <video ref="video_reelS" id="video-small" class="reel" controls>
                    <source src="../assets/video/PortafolioReel-movil.mp4" type="video/mp4">
                </video>
            </div>

            <b-navbar variant="faded" type="light" class="navbar">
                <b-navbar-brand href="#" >
                    <img class="img-nav" src="../assets/img/LogoPrincipal.svg">
                </b-navbar-brand>
            </b-navbar>

            <div class="nav-collap">
                <input v-b-toggle.sidebar-right type="checkbox" id="navbar" class="input-menu">
                <label for="navbar">
                    <div class="menu">
                        <span class="hamburguer"></span>
                    </div>
                </label>
                <b-sidebar id="sidebar-right" class="menu-color" width="100%" no-header title="Sidebar" right>
                    <input v-b-toggle.sidebar-right type="checkbox" id="navbar" class="input-menu">
                    <label for="navbar">
                        <div class="menu-close">
                            <span class="hamburguer"></span>
                        </div>
                    </label>
                    <img class="img-nav-menu" src="../assets/img/LogoPrincipal.svg">
                <div class="px-3 py-4">

                    <ul class="ul-menu">
                        <li class="li-menu"><a v-on:click="esconder" href="" class="a-menu">{{ $t('header.home') }}</a></li>
                        <li class="li-menu"  @click="esconder">
                            <router-link  :to="{path: '/#about-section'}" class="a-menu li_about">{{ $t('header.about') }}</router-link>
                        </li>
                        <li class="li-menu" v-on:click="esconder">
                            <router-link :to="{path: '/#team-section'}" class="a-menu">{{ $t('header.team') }}</router-link>
                        </li>
                        <li class="li-menu" v-on:click="esconder">
                            <router-link :to="{path: '/#service-section'}" class="a-menu">{{ $t('header.services') }}</router-link>
                        </li>
                        <li class="li-menu" v-on:click="esconder">
                            <router-link :to="{path: '/#portfolio-section'}" class="a-menu">{{ $t('header.portfolio') }}</router-link>
                        </li>
                        <li class="li-menu" v-on:click="esconder">
                            <router-link v-on:click="esconder" :to="{path: '/#customers-section'}" class="a-menu">{{ $t('header.customers') }}</router-link>
                        </li>
                        <li class="li-menu"  v-on:click="esconder">
                            <router-link v-on:click="esconder" :to="{path: '/#contact-section'}" class="a-menu">{{ $t('header.contact') }}</router-link>
                        </li>
                    </ul>

                    <div class="div-lenguaje">
                        <LanguageSwitcher></LanguageSwitcher>
                    </div>

                    
                </div>
                </b-sidebar>
            </div>

            <div class="header-azul" id="head-azul" :class="[animatee, fadeRightt,sloww]" ></div>

            <div ref="navbarh" id="navbar-h" class="hide">
                <nav>
                    <img class="img-nav-hide"  src="../assets/img/LogoSecundario.svg">
                    <label id="label-section" class="label-nav-hide">{{sectionName}}</label>
                </nav>
                <input v-b-toggle.sidebar-right type="checkbox" id="navbar" class="input-menu">
                <label for="navbar">
                    <div class="menu-h">
                        <span class="hamburguer"></span>
                    </div>
                </label>
            </div>
        </div>
        <div class="header content">
            
            <div class="header-video" id="idvideo">
                <!-- poster="../assets/img/FondoContacto.png" -->
                <video onloadedmetadata="this.muted=true" onloadeddata="this.play();" id="video-mar" playsinline muted="muted" autoplay loop src="../assets/video/Mar_Fondo.mp4"></video>
            </div>
            <!-- <div class="embed-responsive embed-responsive-16by9" id="idvideo">
                <video class="embed-responsive embed-responsive-16by9" style="width:100%" src="../assets/video/Mar_Fondo.mp4" allowfullscreen></video>
            </div> -->

            <div class="header-overlay"></div>
            <div class="header-content">
                <h1>{{$t('header.title-p1')}} <span class="title-over-c" id="title-over1">{{$t('header.title-p2')}}</span> {{$t('header.title-p3')}} <span class="title-over-c" id="title-over2">{{$t('header.title-p4')}}</span> {{$t('header.title-p5')}}<span class="title-over-c" id="title-over3">{{$t('header.title-p6')}}</span></h1>

                <b-container class=" fluid content-buttons" >
                    <b-row align-h="end" class="content-buttons-row">
                        <b-col offset-lg="5" offset-md="2" offset-sm="2">
                            <button v-on:click="start_reel" class="btn_headerf"><b-icon :icon="iconVideo"></b-icon>{{  $t('header.btn-reel') }}</button>
                            <button class="btn_headerf btn-comenzar" onclick="location.href='#section-contact'">{{ $t('header.btn-start') }}</button>
                        </b-col>
                    </b-row>
                </b-container>
            </div>

        </div>
        
    </header>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher'

export default {
    name: 'HeadComponent',
    components: {
        LanguageSwitcher
    },
    data(){
        return{
            iconVideo: "play",
            visibilityPlay: "visible",
            sectionName: this.$i18n.t('header.home'),
            scroll:true, 
            visibilityReel:"none",
            inde:"5",
            fullVideoReel:"trailer-reel",
            animate: "animate__animated",
            fadeRight:"animate__fadeInLeft",
            slow:"animate__fast",
            isLoad:true,
            loaderrrIm:this.$i18n.t('header.loading'),
            loadIm:require('@/assets/img/Loader.gif'),
            titleAbout:this.$i18n.t('header.about'),
            animatee: "animate__animated",
            fadeRightt:"",
            sloww:""
            
        }
    },
    // created(){
    //     this.$data.loadIm=this.$i18n.t('header.loading');
    // },
    methods:
    {
        ver(){
            var title1= document.getElementById('title-over1');
            title1.classList.add('slice');
        },
        cambio(){
         
        },
        getImgUrl() { 
            return require(this.loaderrrIm);
        } ,
        changeLeng(){
            // // let select=this.$refs[this.$i18n.locale];
            // let select=document.getElementsByClassName(''+this.$i18n.locale);
            // // select.classList.add('active-locale');
            // console.log(select);
        },
        tamVentana() {
        var tam = [0, 0];
        var screenT=screen.height;
        console.log(screenT);
            if (typeof window.innerWidth != 'undefined')
            {
                tam = [window.innerWidth,window.innerHeight];
            }
            else if (typeof document.documentElement != 'undefined'
                && typeof document.documentElement.clientWidth !=
                'undefined' && document.documentElement.clientWidth != 0)
            {
                tam = [
                    document.documentElement.clientWidth,
                    document.documentElement.clientHeight
                ];
            }
            else   {
                tam = [
                    document.getElementsByTagName('body')[0].clientWidth,
                    document.getElementsByTagName('body')[0].clientHeight
                ];
            }

            console.log("tamaño en pantalla "+tam[0]);
            return tam;
        },
        habilitar(){
             
            // window.onscroll = null;
            let scll = document.querySelector("body");
            this.scroll=true;
            scll.setAttribute("style", "overflow-y: visible");
            document.querySelector('.input-menu-h').removeAttribute("checked");
            document.getElementById('nav-h').removeAttribute('checked');
            document.querySelector('.input-menu-h').checked=false;
        },
        esconder(dat){
             
            document.querySelector('.input-menu').removeAttribute("checked");
            document.getElementById('navbar').removeAttribute('checked');
            document.querySelector('.input-menu').checked=false;
            let lis=document.querySelectorAll('.li-menu');
            let scll = document.querySelector("body");
            this.scroll=true;
            scll.setAttribute("style", "overflow-y: visible");

            for (const li of lis) {
                li.classList.remove('acti');
            }

            let active_li;

            if(dat===2){
                active_li=document.querySelectorAll(".li-about");
                for (const li of active_li) {
                    li.classList.add('acti');
                }
            }

        },
        start_reel(){
            let scll = document.querySelector("body");
            let videoCur=document.querySelectorAll(".reel");

            for (const video of videoCur) {
                video.style.display="none";
            }

            let tam=this.tamVentana();
            console.log("el tamaño en el start reel: "+tam[0]);

            if(tam[0]>600){
                console.log("Se activa el video en resolución low");

                var vid=this.$refs.video_reel;
                vid.muted=false;
                vid.play();
                vid.style.display="block";
            }
            else{
                console.log("Se activa el video en resolución sm");
                var vids=this.$refs.video_reelS;
                vids.muted=false;
                vids.play();
                vids.style.display="block";
            }
            this.visibilityReel = "block"; 
            scll.setAttribute("style", "overflow-y: hidden");
        
        },
        close_reel() {

        let scll = document.querySelector("body");
        this.visibilityReel = "none";
        var vid=this.$refs.video_reel;
        var vids=this.$refs.video_reelS;
        vid.muted=true;
        vid.pause();
        vids.muted=true;
        vids.pause();
        scll.setAttribute("style", "overflow-y: visible");
        }
//HASTA AQUI SERVIA VIDEO REEL Y EL RESTO DE COMPONENTES QUE HEMOS HECHO
    },
    created: function(){
        // const vm = this;
        // let scll = document.querySelector("body");
        // scll.setAttribute("style", "overflow-y: hidden");
    },
    mounted: function () {

        console.log("Se va a inicializar la carga!");
        // const vm = this;
        let scll = document.querySelector("body");
        scll.setAttribute("style", "overflow-y: hidden");

        // var div_load=vm.$refs.loade;
        // div_load.style.display="block";

        // document.addEventListener("DOMContentLoaded", function(event) {
        //     // - Code to execute when all DOM content is loaded. 
        //     // - including fonts, images, etc.
        //     console.log(event);
        //     console.log("DOM is ready sin imagenes!");

        //     document.onreadystatechange = () => {
        //     if (document.readyState == "complete") {
        //         console.log('Page completed with image and files!')

        //         setTimeout(function(){
        //             this.isLoad = false;
        //             var div_load=vm.$refs.loade;
        //             div_load.style.display="none";
        //             let scll = document.querySelector("body");
        //             scll.setAttribute("style", "overflow-y: visible");

        //             let video_mar=document.querySelector("#video-mar");
        //             video_mar.muted=true;
        //             video_mar.play().then(() => {
        //                 console.log('Autoplay success!');
        //             }).catch((error) => {
        //                 console.warning('Autoplay error', error);
        //             });

        //             var tope=1;
        //             if(sectionScroll<5 || sectionScroll===0 ){
        //                 var intervalo=setInterval(mensaje,1300);
        //             }

        //             function mensaje() {
        //                 var title= document.getElementById('title-over'+tope);
        //                 title.classList.add('slice');
        //                 tope++;
        //                 if (tope>=4) {
        //                     clearInterval(intervalo);
        //                 }
        //             }
        //         }, 3000);
        //     }
        // }

            
        // });
        
        var element = document.getElementById('video-small');

        ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange", "webkitendfullscreen"].forEach(
            eventType => element.addEventListener(eventType, exitHandler, false)
        );
        const vmm = this;
        function exitHandler() {
            if (!document.fullscreenElement) {
                vmm.close_reel();
            }
        }
        
        var widthbrow=window.outerWidth;
        let videoMar=document.querySelector("#video-mar");
        if(widthbrow<=600){
            videoMar.setAttribute("src",require("../assets/video/Mar_Fondo_Low.mp4"))
        }


        //DETECTAR TAMAÑO DE PANTALLA PARA VIDEO -----------------------------------------
        tamVideo();
        function tamVideo(){
            var screenT=screen.height;

            let headerGen = document.querySelector('.header');
            let headerVideo= document.querySelector('.header-video');
            let headerOver= document.querySelector('.header-overlay');
            let headerAzul= document.querySelector('.header-azul');
            headerGen.style.height=`${screenT}px`;
            headerVideo.style.height=`${screenT}px`;
            headerOver.style.height=`${screenT}px`;
            headerAzul.style.height=`${screenT}px`;

            // var widthbrow=window.outerWidth;
            // let videoMar=document.querySelector("#video-mar");
            // if(widthbrow<=600){
            //     videoMar.setAttribute("src",require("../assets/video/Mar_Fondo_Low.mp4"));
            // }
            // else{
            //     videoMar.setAttribute("src",require("../assets/video/Mar_Fondo_Low.mp4"));
            // }
        }

        window.addEventListener("resize", tamVideo);

        // window.addEventListener("resize", tamVentana);

        //---------------------------------------------------------------------------------
    
        const vm=this;     
        var doc = document.documentElement;
        var w   = window;
        vm.scroll =true;

        var curScroll       = w.scrollY || doc.scrollTop;
        var sectionScroll   = w.scrollY || doc.scrollTop;
        var staticScroll    = w.scrollY || doc.scrollTop;
        var prevScroll      = w.scrollY || doc.scrollTop;
        var curDirection    = 0;
        var prevDirection   = 0;

        var header= document.getElementById('navbar-h');
        let staticPoint     = document.querySelector("#idvideo").clientHeight;

        let homeSection    = document.getElementById("idvideo");
        let homeCords      = homeSection.getBoundingClientRect();
        let homeHeight     =homeCords.height;      


        let aboutSection    = document.getElementById("about-section");
        let aboutCords      = aboutSection.getBoundingClientRect();
        let aboutHeight     = aboutCords.height;


        let videoSection    = document.getElementById("video-section");
        let videoCords      = videoSection.getBoundingClientRect();
        let videoHeight     = videoCords.height;

        let teamSection    = document.getElementById("team-section");
        let teamCords      = teamSection.getBoundingClientRect();
        let teamHeight     = teamCords.height;

        let serviceSection    = document.getElementById("service-section");
        let serviceCords      = serviceSection.getBoundingClientRect();
        let serviceHeight     = serviceCords.height;

        let portSection    = document.getElementById("portfolio-section");
        let portCords      = portSection.getBoundingClientRect();
        let portHeight     = portCords.height;

        let customerSection    = document.getElementById("customers-section");
        let customerCords      = customerSection.getBoundingClientRect();
        let customerHeight     = customerCords.height;

        let contactSection    = document.getElementById("contact-section");
        let contactCords      = contactSection.getBoundingClientRect();
        let contactHeight     = contactCords.height;

        // console.log(homeHeight);
        // console.log(aboutHeight);
        // console.log(videoHeight);
        // console.log(teamHeight);
        aboutHeight=aboutHeight+videoHeight;
        teamHeight=teamHeight+aboutHeight
        serviceHeight=serviceHeight+teamHeight;
        portHeight=portHeight+serviceHeight;
        customerHeight=customerHeight+portHeight;
        contactHeight=contactHeight+customerHeight;

        sectionScroll   = w.scrollY || doc.scrollTop;


        // document.addEventListener("DOMContentLoaded", inicializar);

        // if (document.addEventListener) {
        //     document.addEventListener("DOMContentLoaded", inicializar, false);

        // }

        // function inicializar(){
            setTimeout(function(){
                this.isLoad = false;
                console.log(this.isLoad);
                var div_load=vm.$refs.loade;
                div_load.style.display="none";
                let video_mar=document.querySelector("#video-mar");
                video_mar.muted=true;
                video_mar.play().then(() => {
                    console.log('Autoplay success!');
                }).catch((error) => {
                    console.warning('Autoplay error', error);
                });
                let scll = document.querySelector("body");
                scll.setAttribute("style", "overflow-y: visible");

                var tope=1;
                if(sectionScroll<5 || sectionScroll===0 ){
                    var intervalo=setInterval(mensaje,1300);
                }

                function mensaje() {
                    var title= document.getElementById('title-over'+tope);
                    title.classList.add('slice');
                    tope++;
                    if (tope>=4) {
                        clearInterval(intervalo);
                    }
                }
            }, 5000);
        // }  10000 


            let title1    = document.getElementById("title-over1");
            let title2    = document.getElementById("title-over2");
            let title3    = document.getElementById("title-over3");

        var checkScroll = function(){

            title1.classList.remove("slice");
            title2.classList.remove("slice");
            title3.classList.remove("slice");

            sectionScroll   = w.scrollY || doc.scrollTop;
            // console.log(sectionScroll);

            if(sectionScroll<5 || sectionScroll===0 ){
                var tope=1;
                var intervalo=setInterval(mensaje,1300);
            }

            if(sectionScroll< homeHeight)
            {
                vm.sectionName=vm.$i18n.t('header.home');
                // console.log("home");
            }

            if(sectionScroll> homeHeight && sectionScroll<=aboutHeight)
            {
                vm.sectionName=vm.$i18n.t('header.about');
                // console.log("about");
            }
            if(sectionScroll> aboutHeight && sectionScroll<teamHeight)
            {
                vm.sectionName=vm.$i18n.t('header.team');
                // console.log("team");
            }
            if(sectionScroll> teamHeight && sectionScroll<serviceHeight)
            {
                vm.sectionName=vm.$i18n.t('header.services');
                const target = document.querySelector(".target");
                const active = document.querySelector(".mynav a.active");

                if (active) {
                    const left = active.getBoundingClientRect().left + window.pageXOffset-2000;
                    const top = active.getBoundingClientRect().top + window.pageYOffset;
                
                    target.style.transition="all 2s ease-in-out";
                    target.style.left = `${left}px`;
                    target.style.top = `${top}px`;
                    
                }

                // console.log("services");
            }
            if(sectionScroll> serviceHeight && sectionScroll<portHeight)
            {
                vm.sectionName=vm.$i18n.t('header.portfolio');

                const target = document.querySelector(".target");
                const active = document.querySelector(".mynav a.active");

                if (active) {
                    const left = active.getBoundingClientRect().left + window.pageXOffset+27;
                    const top = active.getBoundingClientRect().top + window.pageYOffset;

                
                    target.style.left = `${left}px`;
                    target.style.transition="all 2s ease-in-out";
                    target.style.top = `${top}px`;
                }
                // console.log("port");
            }

            if(sectionScroll> portHeight && sectionScroll<customerHeight)
            {
                vm.sectionName=vm.$i18n.t('header.customers');
                // console.log("customer");
            }
            if(sectionScroll> customerHeight && sectionScroll<contactHeight)
            {
                vm.sectionName=vm.$i18n.t('header.contact');
                // console.log("customer");
            }

            function mensaje() {
                var title= document.getElementById('title-over'+tope);

                if(title!==null){
                    title.classList.add('slice');
                    tope++;
                    if (tope>=4) {
                        clearInterval(intervalo);
                    }

                }
                else{
                   clearInterval(intervalo); 
                }
                
            }

            if(vm.scroll===true){
                // console.log("se esta moviendo???");

                curScroll       = w.scrollY || doc.scrollTop;
                staticScroll    = w.scrollY || doc.scrollTop;
                
                if(curScroll > prevScroll){
                    curDirection = 2;
                    // console.log(curDirection);
                }
                else{
                    curDirection = 1;
                    // console.log(curDirection);
                }

                if(curDirection !== prevDirection){
                    togleHeader();
                }
                if(staticScroll<=staticPoint){
                    header.classList.add('hide');
                }
                prevDirection=curDirection;
                prevScroll=curScroll;
            }
        }
        var togleHeader = function(){
            
            if(curDirection === 2 ){
                header.classList.add('hide');
            }
            else if(curDirection === 1){
                header.classList.remove('hide');
            }
        }


        window.addEventListener('scroll',checkScroll);

        // let controles=document.getElementById("video-reelw").controls;
        // console.log(controles);

        


        //EVENT TO CHECK MENU AND DISABLE SCROLL

        // const selectElement = document.querySelector('.input-menu-h');
        // // const selectLink = document.querySelector('.a-menu-h');

        // selectElement.addEventListener('change', () => {
        //     var decider = document.getElementById('nav-h');
        //     let scll = document.querySelector("body");
        //     if(decider.checked){

        //         // disableScroll();
        //         scll.setAttribute("style", "overflow-y: hidden");
        //         vm.scroll=false;
        //     } else {
        //         // enableScroll();
        //         scll.setAttribute("style", "overflow-y: visible");
        //         vm.scroll=true;
        //     }
        // });

        const selectNav = document.querySelector('.input-menu');
        selectNav.addEventListener('change', () => {
            var decider = document.getElementById('navbar');
            let scll = document.querySelector("body");
            if(decider.checked){
                scll.setAttribute("style", "overflow-y: hidden");
                vm.scroll=false;
            } else {
                scll.setAttribute("style", "overflow-y: visible");
                vm.scroll=true;
            }
        });


        // const selectNav = document.querySelector('.input-menu');
        // const selectLink = document.querySelector('.a-menu-h');

        // function disableScroll(){  
        //     var x = window.scrollX;
        //     var y = window.scrollY;
        //     window.onscroll = function(){ window.scrollTo(x, y) };
        //     vm.scroll=false;
        // }

        // function enableScroll(){  
        //     window.onscroll = null;
        //     vm.scroll=true;
        // }
        // console.log("dejar cargar");
    },
}
</script>

<style>

*{
    box-sizing: border-box;
}
html{
    scroll-behavior: smooth;
}
body{
    margin:0;
    font-size: 20px;
    /* line-height: 1.5; */
    color: #ffffff;
    overflow-x: hidden;
}

.width-img{
    width: 70%; 
    
}



.acti{
    font-family: 'Gotham Bold Regular';
    color: #04182E !important;
}

.loader{
    position: fixed;
    z-index: 6;
    background: #1D2B3C;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.close-reel{
  position: absolute;
  right: 5%;
  top: 7%;
  cursor: pointer;
  z-index: 5;
  font-size: 50px;
  color: #FFFFFF;

}

.header-video-reel{
    width: 100%;
    /* height: 100vh; */
    display: flex;
    z-index: 5;
}

.trailer-reel{
    position: fixed !important;
}

.header{
    height: 100vh;
    display: flex;
    /* align-items: center; */
    color: #ffffff;
    /* align-items: center; */
}
.content{
    max-width: 120rem;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: left;
    
}
.header-video{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    /* height: 130vh; */
    overflow: hidden;
}
.header-video video{
    min-width: 100%;
    min-height: 100%;
}

.header-overlay{
    /* height: 130vh; */
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    background: #0000002c;
    z-index: 1;
    opacity: .8;
}
.header-nav{
    z-index: 2;
    position: absolute;  
    /* this line exist before, this is a original design */
    width: 100vw;
    /* position: fixed !important; */
}

.header-nav .img-nav{
    width: 18rem;
    height: 18rem;
    margin-left: 4%;
    margin-top: 10px;
    position: absolute;
    z-index: 4;
}

.header-nav .img-nav-menu{
    width: 18rem;
    height: 18rem;
    margin-left: 3%;
    margin-top: 2% !important;
}

.header-content{
    z-index: 1;
}
.header-content h1{
    font-family: 'Gotham Medium Regular';
    letter-spacing: 3.46px !important;
    font-size: 45px !important;
    line-height: 63px !important;
    /* letter-spacing: 4px !important;
    font-size: 30px !important;
    line-height: 40px !important; */
    color: #ffffff;
    margin-left: 25rem;
    margin-right: 10rem;
    margin-top: 25rem; 
}

.content-buttons{
    padding-right: 0 !important;
    margin-right: 0 !important;
}
.content-buttons-row{
    margin-left: -6% !important;
    margin-right: 10% !important;
    flex-flow: column !important;
}

.header-azul{
    height: 100vh;
    width: 0vw;
    position: absolute;
    top: 0;
    right: 0;
    background: transparent;
    /* -webkit-transition: all ease-in-out 1s !important;
    -moz-transition: all ease-in-out 1s !important;
    transition: all 1s ease !important; */
}
.menu{
    background-color: transparent;
    background-image: url(../assets/img/Menu.svg);
    margin-top: 0%;
    cursor: pointer !important;
    width: 2rem !important;
    height: 2rem !important;
    right: 60px !important;
    position: absolute !important;
    transition: box-shadow .2s cubic-bezier(.25, .5, .22, .5) !important;
    z-index: 3 !important;
    color: #fff !important;
    background-color: transparent !important;
    border-color: transparent !important;
    border: none !important;
}

.menu:focus{
    outline: 0;
    box-shadow: 0 0 0 0 transparent !important;
    
}

.menu-close{
    background-color: transparent;
    /* background-image: url(../assets/img/Menu.svg); */
    background-image: url(../assets/img/Tache.svg);
    margin-top: -5%;
    cursor: pointer !important;
    width: 2rem !important;
    height: 2rem !important;
    right: 44px !important;
    position: absolute !important;
    z-index: 3 !important;
    color: #fff !important;
    background-color: transparent !important;
    border-color: transparent !important;
    border: none !important;
}


.menu-color .bg-light{
    background:  #2ABECC !important;
}

.input-menu{
    display: none;
}
.input-menu:checked ~ label .menu{
    box-shadow: 0 0 0 100vh #2ABECC, 1 0 0 100vw #2ABECC !important;
    background-image: url(../assets/img/Tache.svg); 
    z-index: 200;
}

.input-menu:checked ~ .header-azul{
    display: block;
    height: 100vh;
    width: 100vw;
    position: absolute;
    background:  #2ABECC;
    /* box-shadow: inset -1px 0 0 0 #2ABECC; */
    /* opacity: 1; */
    /* transition: box-shadow .2s cubic-bezier(.20, 1, .22, 1) !important; */
}


.input-menu:checked ~ label .hamburguer{
    transform: rotate(45deg);
}

.input-menu:checked ~.header-azul .ul-menu{
    display:block;
}

.input-menu:checked ~ .li-menu a{
    color: white !important;
}

.input-menu:checked ~ .header-nav img{
    width: 10rem !important;
    height: 10rem !important;
    margin-left: 2% !important;
}

.ul-menu{
    
    font-family: 'Gotham Bold Regular';
    letter-spacing: 4.24px;
    font-size: 55px !important;
    line-height: 64px !important;
    position: absolute;
    top: 200px;
    left: 45%;
    list-style: none;
    /* display: none; */
    /* z-index: 3; */
}


.li-menu{
    margin-top: 20px;
}
.li-menu a{
    color: white;
    transform: all 500ms !important;
    position: relative !important;
}

.li-menu a:before{
    content: '';
    position: absolute !important;
    top: 45px !important;
    left: -30px !important;
    width: 0 !important;
    height: 5px !important;
    background: #04182E !important;
    transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
}

.li-menu a:hover:before{
    width: 30px !important;
}
.li-menu a:hover{
    color: #04182E !important;
    margin-left: 30px !important;
} 
.a-menu{ 
    color: white !important;
    display: block !;
    text-decoration: none !important;
}

/* .div-lenguaje{
    display: none;
} */
/* .input-menu:checked ~ .header-azul .div-lenguaje{
    display:block;
} */

/* NAVBAR OCULTO------------------------------------------------------------------------------------------ */
#navbar-h{
    background: #fff;
    width: 100vw;
    height: 70px;
    position: fixed !important;
    top: 0px !important;
    z-index: 1;
} 
#navbar-h.hide{
    top: -150px !important;
    /* display: none; */
}
.img-nav-hide{
    width: 3rem !important;
    height: 3rem !important;
    margin-left: 1.2% !important;
    margin-top: .7%;
    z-index: 4;
}

.img-navh{
    width: 18rem;
    height: 18rem;
    margin-left: 4%;
    margin-top: 2%;
    position: absolute;
    z-index: 10;
    display: none;
}
.label-nav-hide{
    font-family: 'Gotham Medium Regular';
    color:#04182E !important;
    position: absolute;
    margin-top: 1.3rem;
    margin-left: 10px;
}

/* MENU */

.header-azul-h{
    /* height: 0vh !important; */
    height: 100vh;
    width: 0vw !important;
    position: absolute;
    top: 0;
    right: 0;
    background: transparent;
    /* z-index: -3; */
    /* opacity: 1; */
    /* box-shadow: inset 0 0 0 0 #2ABECC; */
    /* -webkit-transition: all ease-in-out 1s !important;
    -moz-transition: all ease-in-out 1s !important;
    transition: all 1s ease !important; */
}

.menu-h{
    background-color: transparent;
    background-image: url(../assets/img/MenuSecundario.svg);
    /* top: 4%; */
    margin-top: -2.9%;
    cursor: pointer !important;
    width: 2rem !important;
    height: 2rem !important;
    right: 60px !important;
    position: absolute !important;
    /* transition: box-shadow .2s cubic-bezier(.25, .5, .22, .5) !important; */
    z-index: 3 !important;
}

.input-menu-h{
    display: none;
}

.input-menu-h:checked ~ label .menu-h{
    /* box-shadow: 0 0 0 100vh #2ABECC, 1 0 0 100vw #2ABECC !important; */
    /* revisar como hacer que el panel tenga el tamaño de la pantalla */
    /* background-color: #2ABECC; */
    background-image: url(../assets/img/Tache.svg); 
    margin-top: -1%;
    z-index: 3;
}

.input-menu-h:checked ~ .header-azul-h{
    display: block;
    height: 100vh !important;
    width: 100vw !important;
    position: absolute;
    background:  #2ABECC;
    /* box-shadow: inset -1px 0 0 0 #2ABECC; */
}

.input-menu-h:checked ~ .header-azul-h .ul-menu-h{
    display:block;
}

.input-menu-h:checked ~ .header-azul-h .img-navh{
    display:block;
}

.input-menu-h:checked ~ .li-menu-h a{
    color: white !important;
}
/* .input-menu-h:checked ~ .header-nav img{
    width: 10rem !important;
    height: 10rem !important;
    margin-left: 2% !important;
} */
.ul-menu-h{
    font-family: 'Gotham Bold Regular';
    letter-spacing: 4.24px;
    font-size: 52px !important;
    line-height: 61px !important;
    position: absolute;
    top: 300px;
    left: 40%;
    list-style: none;
    display: none;
    /* transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02); */
    z-index: 3;
}

.li-menu-h{
    margin-top: 20px;
}

.li-menu-h a{
    color: white !important;
    transform: all 300ms !important;
    position: relative !important;
}

.li-menu-h a:before{
    content: '';
    position: absolute !important;
    top: 50px !important;
    left: -30px !important;
    width: 0 !important;
    height: 5px !important;
    background: #04182E !important;
    transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
}

.li-menu-h a:hover:before{
    width: 30px !important;
}
.li-menu-h a:hover{
    color: #04182E !important;
    margin-left: 30px !important;
} 
.a-menu-h{ 
    color: white !important;
    display: block !;
    text-decoration: none !important;
}
.div-lenguaje-h{
    display: none;
}
.input-menu-h:checked ~ .header-azul-h .div-lenguaje-h{
    display:block;
}

/* ------------------------------------------------------------------------------------------- */


.btn_headerf:hover{
    background-position: -100% 0;
    color:#04182E !important;
}
.btn_headerf{
    font-family: "Gotham Book Regular" !important;
    /* font-size: 15px !important; */
    letter-spacing: 0 !important;
    font-size: 20px !important;
    line-height: 21px !important;
    color: #ffffff !important;
    /* padding: 12px 5px !important; */
    background: transparent;
    text-align: center;
    text-decoration: none;
    border: 2px solid #ffffff !important;
    border-radius: 0% !important;
    margin-left: 2%;
    margin-top: 10%;

    /* se cambio tamaño segun la especificación del doc*/
    width: 324px;
    height: 76px;

    background-size: 200% 100%;
    background-image: linear-gradient(to right, transparent 50%, #fff 50%);
    -webkit-transition: background-position 1s;
    -moz-transition: background-position 1s;
    transition: background-position 1s;
}
.btn_headerf .b-icon{
  font-size: 20px !important;
  color: #ffffff;
}
.btn_headerf:hover .b-icon{
  color:#04182E !important;
}

.title-over-c{
    background:transparent;
    background-size: 200% 100%;
    background-image: linear-gradient(to right, transparent 50%, #22c3d154 50%);
    -webkit-transition: background-position 1.5s;
    -moz-transition: background-position 1.5s;
    transition: background-position 1.5s;
    padding: 1px 1px 5px 5px !important;
}

#title-over1.slice{
    background-position: -100% 0;
    /* color:#04182E !important; */
}


#title-over2.slice{
    background-position: -100% 0;
    /* color:#04182E !important; */
}

#title-over3.slice{
    background-position: -100% 0;
    /* color:#04182E !important; */
}

/* @media screen and (max-width: 960px)-------------------------------------------------------------------{ */
.load-sm{
    display: none;
}
@media screen and (max-width: 960px) and (min-width: 100px){
    .loader{
        position: fixed;
        z-index: 6;
        background: #1D2B3C;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .content{
        padding-left: 3rem !important;
        padding-right: 3rem !important;
        text-align: left;
    }
   

    .header-content h1{
        font-family: 'Gotham Medium Regular';
        letter-spacing: 1.39px !important;
        font-size: 18px !important;
        line-height: 28px !important;
        color: #ffffff;
        /* margin-left: 22px;
        margin-right: 10px; */
        margin-left: -5px;
        margin-right: -21px;
        margin-top: 19rem;
    }
    .header-nav .img-nav{
        width: 13rem;
        height: 13rem;
        margin-left: 20%;
        margin-top: 15% !important;
    }

    .header-nav .img-nav-menu{
        width: 13rem;
        height: 13rem;
        margin-left: 25%;
        margin-top: 15% !important;
    }
    
    .content-buttons-row{
        margin-left: -10px !important;
        margin-right: 7% !important;
        margin-top: 10%;
        flex-flow: column !important;
    }
    .input-menu:checked ~ .ul-menu{
        display: block;
        top: 300px !important;
        left: 8% !important;
    }


    .menu{
        background-color: transparent;
        background-image: url(../assets/img/Menu.svg);
        top: 25px;
        cursor: pointer !important;
        width: 2rem !important;
        height: 2rem !important;
        right: 30px !important;
    }

    .ul-menu{
        font-family: 'Gotham Medium Regular';
        letter-spacing: 1.69px;
        font-size: 22px !important;
        line-height: 30px !important;
        top: 250px !important;
        left: 1% !important;
        list-style: none;
        /* display: none; */
        margin-top:15%;
    }

    .menu-close{
        background-color: transparent;
        background-image: url(../assets/img/Tache.svg);
        margin-top: -24%;
        cursor: pointer !important;
        width: 2rem !important;
        height: 2rem !important;
        right: 30px !important;
        position: absolute !important;
        z-index: 3 !important;
        color: #fff !important;
        background-color: transparent !important;
        border-color: transparent !important;
        border: none !important;
    }

    .li-menu a:before{
        content: '';
        position: absolute !important;
        top: 17px !important;
        left: -13px !important;
        width: 0 !important;
        height: 2px !important;
        background: #04182E !important;
        transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
    }
    .li-menu a:hover:before{
        width: 13px !important;
    }
    .header-azul{
        height: 100vh;
        width: 0vw;
        position: absolute;
        top: 0;
        right: 0;
        background: transparent;
        animation: rightLeft 5s;
        /* animation: rightLeft 5s; */
        /* box-shadow: inset 0 0 0 0 transparent;*/
        /* -webkit-transition: all ease .3s !important;
        -moz-transition: all ease .3s !important;
        transition: all .3s ease !important;  */
    }
    .input-menu:checked ~ .header-azul{
        display: block;
        height: 100vh;
        width: 100vw;
        position: absolute;
        background:  #2ABECC;
        /* animation: leftRight 5s; */
        /* box-shadow: inset -1px 0 0 0 #2ABECC; */
    }
    .btn_headerf{
    
        color: #ffffff !important;
        font-family: 'Gotham Bold Regular';
        letter-spacing: 0 !important;
        font-size: 14px !important;
        line-height: 15px !important;
        background: transparent;
        text-align: center;
        text-decoration: none;
        border: 2px solid #ffffff !important;
        border-radius: 0% !important;
        margin-left: 1.8%;
        margin-top: 7%;
        width: 250px;
        height: 40px;

        background-size: 200% 100%;
        background-image: linear-gradient(to right, transparent 50%, #fff 50%);
        -webkit-transition: background-position 1s;
        -moz-transition: background-position 1s;
        transition: background-position 1s;
    }

    .btn_headerf .b-icon{
        font-size: 20px !important;
        color: #ffffff;
        vertical-align: -5px !important;
    }

    /* NAV OCULTO */

    .img-nav-hide{
        margin-top: 1.8% !important;
    }

    #navbar-h{
        background: #fff;
        width: 100vw;
        height: 55px;
        position: fixed !important;
        top: 0px !important;
        z-index: 1;
    } 

    .img-navh{
        width: 13rem;
        height: 13rem;
        margin-left: 25%;
        margin-top: 25px !important;
        position: absolute;
        z-index: 4;
        display: none;
    }
    .menu-h{
        background-color: transparent;
        background-image: url(../assets/img/MenuSecundario.svg);
        top: 24px;
        cursor: pointer !important;
        width: 2rem !important;
        height: 2rem !important;
        right: 30px !important;
    }

    .ul-menu-h{
        font-family: 'Gotham Medium Regular';
        letter-spacing: 1.69px;
        font-size: 22px !important;
        line-height: 30px !important;
        top: 250px !important;
        left: 1% !important;
        list-style: none;
        font-size: 45px;
        display: none;
        transition: 1s .1s cubic-bezier(0, 1.07, 0, 1.02);
    }
    .li-menu-h a:before{
        content: '';
        position: absolute !important;
        top: 12px !important;
        left: -13px !important;
        width: 0 !important;
        height: 2px !important;
        background: #04182E !important;
        transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
    }
    .li-menu-h a:hover:before{
        width: 13px !important;
    }
    .header-azul-h{
        height: 100vh;
        width: 0vw;
        position: absolute;
        top: 0;
        right: 0;
        background: transparent;
        z-index: -3;
        opacity: 1;
        box-shadow: inset 0 0 0 0 #2ABECC;
        -webkit-transition: all ease-in-out 1s !important;
        -moz-transition: all ease-in-out 1s !important;
        transition: all 1s ease !important;
        z-index: 2;
    }
    .input-menu-h:checked ~ .header-azul-h{
        display: block;
        height: 100vh;
        width: 100vw;
        position: absolute;
        background:  #2ABECC;
        box-shadow: inset 0 0 0 0 #2ABECC;
    
    }
    

.label-nav-hide{
    font-family: 'Gotham Medium Regular';
    letter-spacing: 2px;
    font-size: 12px !important;
    line-height: 18px !important;
    color:#04182E !important;
    position: absolute;
    margin-top: 1.1rem;
    margin-left: 10px;
}

.trailer-reel{
  /* position: fixed; */
  z-index: 5;
  background: #000000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-video-reel{
    width: 100vw;
    display: flex;
    z-index: 5;
    /* justify-content: center;
    align-items: center; */
}

.width-img{
    width: 80%;
    margin-left: -20px;
    
}
.load-sm{
    display: block;
}
.load-large{
    display: none;
}

}

/* @media screen and (max-width: 1400px){ */



@media screen and (max-width: 1800px) and (min-width: 961px){

    .header-content h1{
        font-family: 'Gotham Medium Regular';
        letter-spacing: 4px !important;
        font-size: 30px !important;
        line-height: 40px !important;
        color: #ffffff;
        margin-left: 20rem;
        margin-right: 10rem;
        margin-top: 15rem;
    
    }
    .header-nav .img-nav{
        width: 12rem;
        height: 12rem;
        margin-left: 3%;
        margin-top: 2%;
    }

    .header-nav .img-nav-menu{
        width: 12rem;
        height: 12rem;
        margin-left: 3%;
        margin-top: 2% !important;
    }

    .menu-close{
        background-color: transparent;
        background-image: url(../assets/img/Tache.svg);
        margin-top: -5%;
        cursor: pointer !important;
        width: 2rem !important;
        height: 2rem !important;
        right: 56px !important;
        position: absolute !important;
        z-index: 3 !important;
        color: #fff !important;
        background-color: transparent !important;
        border-color: transparent !important;
        border: none !important;
    }

    /* .header-nav .img-nav-menu{
        width: 12rem;
        height: 12rem;
        margin-left: 3%;
        margin-top: 2%;
    } */
    
    .content-buttons-row{
        margin-left: 15% !important;
        margin-right: 7% !important;
        flex-flow: column !important;
    }

    .input-menu:checked ~ .ul-menu{
        display: block;
        top: 200px;
        left: 35%;
    }

    .ul-menu{
        font-family: 'Gotham Bold Regular';
        letter-spacing: 4.24px;
        font-size: 30px !important;
        line-height: 37px !important;
        top: 200px;
        left: 35%;
        list-style: none;
        /* display: none; */
    }
    .li-menu a:before{
        content: '';
        position: absolute !important;
        top: 30px !important;
        left: -25px !important;
        width: 0 !important;
        height: 4px !important;
        background: #04182E !important;
        transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
    }

    .li-menu a:hover:before{
        width: 25px !important;
    }

    .btn_headerf{
        font-family: "Gotham Book Regular" !important;
        /* font-size: 15px !important; */
        color: #ffffff !important;
        /* padding: 10px 5px !important; */
        letter-spacing: 0 !important;
        font-size: 15px !important;
        line-height: 16px !important;
        background: transparent;
        text-align: center;
        text-decoration: none;
        border: 2px solid #ffffff !important;
        border-radius: 0% !important;
        margin-left: 2%;
        margin-top: 4%;
        width: 250px;
        height: 50px;

        background-size: 200% 100%;
        background-image: linear-gradient(to right, transparent 50%, #fff 50%);
        -webkit-transition: background-position 1s;
        -moz-transition: background-position 1s;
        transition: background-position 1s;
    }

    /* NAV OCULTO */

    #navbar-h{
        background: #fff;
        width: 100vw;
        height: 62px;
        position: fixed !important;
        top: 0 !important;
        z-index: 1;
    }

    .label-nav-hide{
        font-family: 'Gotham Medium Regular';
        color:#04182E !important;
        position: absolute;
        margin-top: 1.1rem;
        margin-left: 10px;
    }

    .img-navh{
        width: 12rem;
        height: 12rem;
        margin-left: 5%;
        margin-top: 2%;
        /* margin-top: -90px; */
        position: absolute;
        z-index: 4;
        display: none;
    }

    .ul-menu-h{
        font-family: 'Gotham Bold Regular';
        letter-spacing: 4.24px;
        font-size: 30px !important;
        line-height: 37px !important;
        top: 200px;
        left: 40%;
        list-style: none;
        display: none;
        transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
        /* z-index: 3; */
    }
    .li-menu-h a:before{
        content: '';
        position: absolute !important;
        top: 30px !important;
        left: -25px !important;
        width: 0 !important;
        height: 4px !important;
        background: #04182E !important;
        transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
    }

    .li-menu-h a:hover:before{
        width: 25px !important;
    }

    .menu-h{
    background-color: transparent;
    background-image: url(../assets/img/MenuSecundario.svg);
    /* top: 4%; */
    margin-top: -4%;
    cursor: pointer !important;
    width: 2rem !important;
    height: 2rem !important;
    right: 60px !important;
    position: absolute !important;
    /* transition: box-shadow .2s cubic-bezier(.25, .5, .22, .5) !important; */
    z-index: 3 !important;

}

}

@keyframes rightLeft {
    from{ margin-right: 0}
    to{ margin-right:-100%}
}

@keyframes leftRight {
    from{ margin-right: -100%;}
    to{ margin-right: 0;}
}
</style>